"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCameraPositionToSeeObject = void 0;
var realms_three_1 = __importDefault(require("realms-three"));
/**
 * Gets the camera position to be able to see the whole object
 */
function getCameraPositionToSeeObject(objs, camera) {
    var fov = camera.fov;
    var bbox = null;
    for (var _i = 0, objs_1 = objs; _i < objs_1.length; _i++) {
        var obj = objs_1[_i];
        if (!bbox) {
            bbox = new realms_three_1.default.Box3().setFromObject(obj);
            continue;
        }
        bbox.expandByObject(obj);
    }
    if (!bbox) {
        return {
            cameraPosition: { x: 10, y: 10, z: 10 },
            cameraLookPosition: { x: 0, y: 0, z: 0 },
        };
    }
    var boxSize = bbox.getSize(new realms_three_1.default.Vector3());
    var calcDistance = function (x1, x2) {
        return Math.sqrt(Math.pow(x1, 2) + Math.pow(x2, 2));
    };
    // Get bounding sphere radius
    var radius = Math.max(calcDistance(boxSize.x, boxSize.y), calcDistance(boxSize.y, boxSize.z), calcDistance(boxSize.z, boxSize.x)) / 2;
    // Code refers to the blog here:
    // https://wejn.org/2020/12/cracking-the-threejs-object-fitting-nut/
    var cameraFov = (Math.PI * camera.fov) / 180;
    var cameraFovh = 2 * Math.atan(Math.tan(fov / 2) * camera.aspect);
    var distance = Math.max(radius / Math.tan(cameraFov / 2), radius / Math.tan(cameraFovh / 2));
    var center = bbox.getCenter(new realms_three_1.default.Vector3());
    return {
        cameraPosition: {
            x: center.x + distance,
            y: center.y + distance,
            z: center.z + distance,
        },
        cameraLookPosition: center,
    };
}
exports.getCameraPositionToSeeObject = getCameraPositionToSeeObject;
